import { render, staticRenderFns } from "./sfzForm.vue?vue&type=template&id=1c2ab3a0&"
import script from "./sfzForm.vue?vue&type=script&lang=js&"
export * from "./sfzForm.vue?vue&type=script&lang=js&"
import style0 from "./sfzForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "sfzForm.vue"
export default component.exports